import { DEFAULT_PAGINATION_STATE } from '@/common/constants'
import { DISPLAY } from '@/projects/display'
export const initialRoomFiltersPaneState = {
  creationDate: [],
  dueDate: [],
  selectedLabels: [],
  projectType: [],
  role: [],
}

export const state = {
  processing: false,
  rooms: null,
  error: null,
  loadingRoomsInfo: false,
  roomLabels: null,
  filtersPane: {
    isOpen: false,
    filters: { ...initialRoomFiltersPaneState },
  },
  sort: 'creationDate',
  displayType: DISPLAY.grid,
  roomsLabelsError: null,
  roomsLabelsPending: false,
  subscriptionLabelsPending: false,
  subscriptionLabels: null,
  subscriptionLabelsError: null,
  dataRoomPricingPending: false,
  dataRoomPricing: null,
  dataRoomPricingError: null,
  dataRoomCustomPricingPending: false,
  dataRoomCustomPricing: {},
  dataRoomCustomPricingError: null,
  lastVisitedRooms: [],
  lastVisitedRoomsPending: false,
  recentRoomsPending: false,
  recentRooms: [],
  recentRoomsError: null,
  searchModeEnabled: false,
  pmRoomsPending: false,
  pmRooms: [],
  pmPagination: { ...DEFAULT_PAGINATION_STATE },
  pmRoomsError: null,
  guestRoomsPending: false,
  guestRooms: [],
  guestPagination: { ...DEFAULT_PAGINATION_STATE },
  guestRoomsError: null,
  existingRoomsLabelsPending: false,
  existingRoomsLabels: [],
  existingRoomsLabelsError: null,
  existingMetadata: {},
  baseQueryParams: {
    pm: {},
    guest: {},
  },
  pmAbortController: null,
  guestAbortController: null,
}
